/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function () {
    const optionSelectors = document.querySelectorAll(".option-selector");
    const mainSelect = document.querySelector('[id^="product-select-"]');

    function updateVariant() {
      let selectedOptions = [];

      optionSelectors.forEach((select) => {
        selectedOptions.push(select.value);
      });

      let found = false;

      for (let option of mainSelect.options) {
        let match = true;
        let inventory_quantity = option.dataset.qty;

        if (option.dataset.option1 && selectedOptions[0] !== option.dataset.option1) {
          match = false;
        }
        if (option.dataset.option2 && selectedOptions[1] !== option.dataset.option2) {
          match = false;
        }
        if (option.dataset.option3 && selectedOptions[2] !== option.dataset.option3) {
          match = false;
        }

        if (match) {
          mainSelect.value = option.value;
          found = true;

          if(inventory_quantity <= 0){
            document.querySelector('.product-unavailable').style.display = 'flex';
          }else{
            document.querySelector('.product-unavailable').style.display = 'none';
          }

          // 🔥 trigger change event (important for Shopify)
          mainSelect.dispatchEvent(new Event("change", { bubbles: true }));
          break;
        }
      }

      if (!found) {
        console.warn("No matching variant found");
      }
    }

    optionSelectors.forEach((select) => {
      select.addEventListener("change", updateVariant);
    });
  });
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
